import {
	ElibrarySettingsDataSource, Product
} from "@sabyr-dev/mist_elibrary/datasource";

export class AcademySettingsDataSource extends ElibrarySettingsDataSource {
	setEmail(product: Product, email: string): Promise<boolean> {
		return fetch(
			`/practicequestion/email/${product}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })
			}
		).then(response => response.json() as Promise<{ unlocked: boolean }>)
			.then(content => content.unlocked);
	}

	async checkEmail(product: Product, email: string): Promise<boolean> {
		const response = await fetch(
			`/practicequestion/unlock/${product}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })
			}
		);
		const content = await response.json() as {unlocked: boolean};
		return content.unlocked;
	}
}
